import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import ReactTooltip from 'react-tooltip'
import { branch } from 'baobab-react/higher-order'
import AlertBox from 'components/authentication/AlertBox'
import Input from 'components/shared/input/Input'
import FacebookButton from 'components/authentication/FacebookButton'
import OrLine from 'components/authentication/OrLine'
import { Button, FormGroup, Checkbox, Image } from 'components/qstrap'
import API from 'utils/API'
import AccessToken from 'utils/AccessToken'
import config from 'config'
import btoaToken from 'utils/btoaToken'
import triggerEvent from 'utils/dataLayer'

const propTypes = {
  successUrl: PropTypes.string,
  redirectLocation: PropTypes.string,
}

class SignIn extends React.Component {
  constructor(props) {
    super(props)

    this.inputs = {}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFacebook = this.handleFacebook.bind(this)

    this.fields = ['email', 'password']
  }

  redirectLocation() {
    // TODO: Deprecate `successUrl` props
    const { successUrl, redirectLocation } = this.props
    const target = successUrl || redirectLocation
    return target
  }

  attributes() {
    const hash = {}
    this.fields.map(field => hash[field] = this.inputs[field].value)
    return hash
  }

  isValid() {
    this.fields.map(field => this.inputs[field].validate())
    return !this.fields.map(field => !!this.inputs[field].validity()).includes(false)
  }

  handleSubmit(e) {
    localStorage.removeItem('aptitude_answers')
    localStorage.removeItem('aptitude_page')

    e.preventDefault()
    this.loader.classList.remove('hide')

    if (this.isValid()) {
      const hash = this.attributes()
      const token = btoaToken(hash.email, hash.password)
      const options = { headers: { Authorization: `Basic ${token}` } }
      const data = {
        client_id: config.client_id,
        client_secret: config.client_secret,
        response_type: 'json',
      }

      API.post(API.endPoints().auth.login, data, options).then((response) => {
        AccessToken.set(response.data.access_token, this.inputs.rememberMe.checked)
        triggerEvent('ga/signin/masuk')
        window.location = this.redirectLocation()
      }).catch(() => {
        this.loginFailedAlert.classList.remove('hide')
        this.loader.classList.add('hide')
      })

      return hash
    }
    return this.loader.classList.add('hide')
  }

  handleFacebook(fbResponse) {
    this.loader.classList.remove('hide')
    API.get(API.endPoints().auth.facebook, { facebook_token: fbResponse.accessToken, client_id: config.client_id }).then((response) => {
      AccessToken.set(response.data.access_token, this.inputs.rememberMe.checked)
      window.location = '/'
    }).catch(() => {
      this.fbNotLinkedAlert.classList.remove('hide')
      this.loader.classList.add('hide')
    })
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="bold m-b-md">{intl.get('account.login_title')}</div>

        <FacebookButton
          callback={this.handleFacebook}
          onClick={() => triggerEvent('ga/signin/facebookconnect')}
        />
        <OrLine />

        <Input
          ref={c => this.inputs.email = c}
          name="email"
          icon="account"
          label={intl.get('account.username_or_email')}
          validations={['required']}
        />

        <Input
          ref={c => this.inputs.password = c}
          name="password"
          type="password"
          icon="password"
          label={intl.get('account.password')}
          validations={['required']}
        />

        <FormGroup className="m-t-lg clearfix" check>
          <div className="pull-sm-right xs-down-m-b-md">
            <a href="/forgot_password" className="pull-sm-right">{intl.get('account.forgot_password')}</a>
          </div>
          <div className="pull-sm-left">
            <Checkbox getRef={c => this.inputs.rememberMe = c}>
              {intl.get('account.this_is_my_device')}
              <Image id="keep-loggged-in" src="/assets/img/help.svg" data-tip={intl.get('account.let_me_keep_loggged_in_hint')} />
              <ReactTooltip className="max-width-sm" />
            </Checkbox>
          </div>
        </FormGroup>

        <FormGroup className="m-t-lg">
          <AlertBox setRef={(c) => { this.loginFailedAlert = c }} text={intl.get('account.login_fail_alert')} />
          <AlertBox setRef={c => this.fbNotLinkedAlert = c} text={intl.get('account.fb_not_linked')} />
        </FormGroup>

        <FormGroup className="m-t-lg" check>
          <Button color="primary" type="submit" block onClick={this.handleSubmit} className="icon-loading-container">
            <i className="icon icon-loading icon-loading-center hide" ref={c => this.loader = c} />
            {intl.get('account.enter')}
          </Button>
        </FormGroup>

        <hr />

        <FormGroup className="m-t-lg text-center" check>
          <div>{intl.get('account.new_to_quipper')}</div>
          <div>
            <a className="bold" href="/signup" onClick={() => triggerEvent('ga/signin/click/daftar')}>
              {intl.get('account.click_here_to_create_account')}
            </a>
          </div>
        </FormGroup>
      </form>
    )
  }
}

SignIn.propTypes = propTypes

export { SignIn }
export default branch({
  redirectLocation: ['serverProps', 'redirect_location'],
})(SignIn)
